<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QnJClE/tc-custom/9781467426756.jpg?1730408761091" alt="This image is the cover for the book The Gospel according to Matthew, The Pillar New Testament Commentary (PNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Gospel according to Matthew, The Pillar New Testament Commentary (PNTC)
      </h1>
      <p class="bookDescription body article font2">
        <p>In the Christian Church the Gospel of Matthew has been considered the most important portrait of Jesus' life and message. Containing Jesus' Sermon on the Mount and a uniquely rich collection of parables, among many other things, Matthew has made a major contribution to the church throughout the centuries, and it still has much to say to the church today.<br/><br/> This superb commentary in the Pillar series explores the meaning and relevance of Matthew in an eminently straightforward fashion. Leon Morris writes for readers who use commentaries to discover further what the Bible means. Throughout, he makes clear what he considers to be the meaning of the Greek text that Matthew has bequeathed to the church. A perceptive introduction precedes Morris's warmhearted verse-by-verse exposition of Matthew, an exposition based on his own literal translation of the text. Now a standard reference work on the Gospel of Matthew, this mature, evangelically oriented commentary will continue to meet the needs of students, pastor, and general readers alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leon Morris
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Leon Morris</B>&#160;(1914-2006) was one of Australia&#39;s most prolific Bible scholars. He wrote over forty other books, including commentaries on Matthew, John, and Thessalonians.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b03b6ab2